import React, { useState, useEffect } from "react";
import styles from "./IBOFilePage.module.css";
import { useHistory, useParams } from "react-router-dom";
import classNames from "classnames";
import LoadingPage from "shared/LoadingPage";

import IBOInfoCard from "Security/IncidentsPage/IBOInfoCard";
import MembershipInfoCard from "Security/IncidentsPage/MembershipInfoCard";
import { Tab, TabContainer } from "shared/TabContainer";
import IncidentsList from "Security/IncidentsPage/IncidentsList";
import IBOAccountList from "Security/IncidentsPage/IBOAccountList";
import History from "shared/@hooks/LookupByIBO/Details/Membership/History";
import CalendarEventDates from "../CalendarPage/CalendarEventDates";
import ChangeStatusModal from "../IncidentsPage/ChangeStatusModal";
import SuspensionBanner from "Security/Shared/SuspensionBanner";

import { useIBOFile } from "./useIBOFile";
import { useIncidents } from "../IncidentsPage/useIncidents";
import { useIBOInfo } from "shared/@hooks/useIBOInfo";
import { useAddresses } from "shared/@hooks/LookupByIBO/Details/Tabs/Addresses/useAddresses";
import EventCardList from "Security/Shared/EventCardList";

const testEventsDate = [
  {
    date: "08 August",
    time: "All Day",
    location: "Phoenix, Arizona",
    name: "Name of calendar event",
    notes:
      "Notes: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    src: "src",
  },
  {
    date: "18 August",
    time: "All Day",
    location: "Phoenix, Arizona",
    name: "Phoenix calendar event",
    notes:
      "Notes: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    src: "src",
  },
  {
    date: "20 August",
    time: "All Day",
    location: "Phoenix, Arizona",
    name: "Phoenix calendar event",
    notes:
      "Notes: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    src: "src",
  },

  {
    date: "09 September",
    time: "2-2:45 MST",
    location: "Spokane, Washington",
    name: "Spokane calendar event",
    notes:
      "Notes: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    src: "src",
  },

  {
    date: "09 October",
    time: "2-2:45 MST",
    location: "Spokane, Washington",
    name: "Spokane calendar event",
    notes:
      "Notes: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    src: "src",
  },
  {
    date: "22 November",
    time: "2-2:45 MST",
    location: "Spokane, Washington",
    name: "Spokane calendar event",
    notes:
      "Notes: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    src: "src",
  },
];

/**
 * Structural component.
 * Contains the info of a given IBO.
 */
export function IBOFilePage() {
  const history = useHistory();
  const { id } = useParams();

  const { data, isLoading } = useIncidents("incidents");
  const {
    platformStatusPut,
    data: platformStatus,
    isLoading: platformIsLoading,
    refetch,
  } = useIBOFile(id);
  const { iboInfo, isLoading: iboInfoIsLoading } = useIBOInfo(id);
  const { addresses, isWaiting } = useAddresses(id);

  const [currentTab, setCurrentTab] = useState("created");
  const [showHistory, setShowHistory] = useState(false);
  const [created, setCreated] = useState([]);
  const [against, setAgainst] = useState([]);
  const [iboData, setIboData] = useState(null);
  const [address, setAddress] = useState(null);
  const [platforms, setPlatforms] = useState(null);
  const [isSuspended, setIsSuspended] = useState(false);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [changeCalendarMonth, setChangeCalendarMonth] = useState(false);

  const [iboItem, setIboItem] = useState({
    name: "",
    number: "",
    email: "",
    phoneNumber: "",
    username: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    status: "",
    current: "",
    pending: "",
    billingDate: "",
  });

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    iboInfo && setIboData(iboInfo);
  }, [iboInfo]);

  useEffect(() => {
    if (addresses) {
      setAddress(addresses);
    }
  }, [addresses]);

  useEffect(() => {
    if (platformStatus) {
      setPlatforms(platformStatus);

      const isSuspended = platformStatus.some(
        (platform) => platform.status === "suspended"
      );

      setIsSuspended(isSuspended);
    }
  }, [platformStatus]);

  useEffect(() => {
    if (iboData && address) {
      setIboItem({
        ...iboItem,
        name:
          iboData.primaryInfo && iboData.primaryInfo.iboName
            ? iboData.primaryInfo.iboName
            : "N/A",
        number: id,
        email:
          iboData.primaryInfo &&
          iboData.primaryInfo.iboA &&
          iboData.primaryInfo.iboA.email
            ? iboData.primaryInfo.iboA.email
            : "N/A",
        phoneNumber:
          iboData.primaryInfo &&
          iboData.primaryInfo.iboA &&
          iboData.primaryInfo.iboA.phone
            ? iboData.primaryInfo.iboA.phone
            : "N/A",
        username:
          iboData.primaryInfo && iboData.primaryInfo.username
            ? iboData.primaryInfo.username
            : "N/A",
        address:
          address && address[0] && address[0].line1 ? address[0].line1 : "N/A",
        city:
          address && address[0] && address[0].city ? address[0].city : "N/A",
        state:
          address && address[0] && address[0].state ? address[0].state : "N/A",
        zip:
          address && address[0] && address[0].postalCode
            ? address[0].postalCode
            : "N/A",
        status:
          iboData.membership && iboData.membership.status
            ? iboData.membership.status
            : "N/A",
        current:
          iboData.membership && iboData.membership.currentMembership
            ? iboData.membership.currentMembership
            : "N/A",
        pending:
          iboData.membership && iboData.membership.pendingMembership
            ? iboData.membership.pendingMembership
            : "No pending Changes",
        billingDate:
          iboData.membership && iboData.membership.nextBillingDate
            ? formatDate(iboData.membership.nextBillingDate)
            : "N/A",
      });
    }
  }, [iboData, address]);

  useEffect(() => {
    if (data) {
      let sortedData = [];
      // '==' vs '===' is needed for search to work properly
      sortedData = data.filter((item) => item.primaryIboNumber == id);
      setCreated(sortedData);
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      let sortedData = [];
      // '==' vs '===' is needed for search to work properly
      sortedData = data.filter((item) => item.complaintAgainst.iboNumber == id);
      setAgainst(sortedData);
    }
  }, [data]);

  function handleChangeStatusOnSend(account, status) {
    let object = {
      platform: {
        name: account,
        status: status,
      },
    };

    platformStatusPut.mutateAsync(object).then(() => {
      refetch();
    });

    setStatusModalOpen(false);
  }

  function handleOpenStatusModal() {
    setStatusModalOpen(true);
  }

  //Calendar
  const [currentDate, setCurrentDate] = useState(new Date());

  const eventDates = testEventsDate.map((event) => {
    const [day, month] = event.date.split(" ");
    const year = new Date().getFullYear();
    return new Date(`${month} ${day}, ${year}`);
  });

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US");
  };

  const handleMonthChange = (date) => {
    setCurrentDate(date);
    setChangeCalendarMonth(true);
  };

  //Shows all events in first load and filter when the calendar arrow clicked
  const filteredEvents = changeCalendarMonth
    ? testEventsDate.filter((event) => {
        const [day, month] = event.date.split(" ");
        const year = currentDate.getFullYear();
        const eventDate = new Date(`${month} ${day}, ${year}`);

        return (
          eventDate.getMonth() === currentDate.getMonth() &&
          eventDate.getFullYear() === currentDate.getFullYear()
        );
      })
    : testEventsDate;

  return (
    <div className={styles.page}>
      <section className={styles.container}>
        <div className={styles.header}>
          <span className={styles.headerIBONumber}>IBO {id}</span>
        </div>
        {isSuspended && <SuspensionBanner suspensionInfo={platforms} />}

        {!isLoading && !iboInfoIsLoading && !isWaiting ? (
          <>
            <div className={styles.header}>
              <h1>{iboItem.name}</h1>
            </div>
            <div className={styles.row}>
              <IBOInfoCard ibo={iboItem} iboPage={true} />
            </div>
            <div className={styles.gap}>
              <MembershipInfoCard
                membership={iboItem}
                showHistory={showHistory}
                onClick={() => {
                  setShowHistory(!showHistory);
                }}
              />
            </div>
            <div
              className={classNames({
                [styles.created]: currentTab === "created",
                [styles.against]: currentTab === "against",
                [styles.accounts]: currentTab === "accounts",
                [styles.calendar]: currentTab === "calendar",
                [styles["rounded-first"]]: currentTab !== "created",
              })}
            >
              <div className={styles.tabsAndHistoryCardContainer}>
                <TabContainer
                  value="created"
                  minHeight="350px"
                  className={styles.tabContainer}
                  children={[
                    <Tab title="Created" value="created">
                      <IncidentsList incidents={created} resultsPerPage={8} />
                    </Tab>,
                    <Tab title="Against" value="against">
                      <IncidentsList incidents={against} resultsPerPage={8} />
                    </Tab>,
                    <Tab title="Accounts" value="accounts">
                      <IBOAccountList
                        accounts={platforms}
                        openModal={handleOpenStatusModal}
                      />
                    </Tab>,
                    <Tab title="Calendar" value="calendar">
                      <div className={styles.calendarContainer}>
                        <div className={styles.calendar}>
                          <CalendarEventDates
                            allowPastDate={true}
                            eventsDate={eventDates}
                            onMonthChange={handleMonthChange}
                          />
                        </div>
                        <div className={styles.cardsContainer}>
                          {filteredEvents.length > 0 ? (
                            <div>
                              <EventCardList eventsArray={filteredEvents} />
                            </div>
                          ) : (
                            <div>No available events.</div>
                          )}
                        </div>
                      </div>
                    </Tab>,
                  ]}
                />
              </div>
            </div>
            <button className={styles.button} onClick={() => history.goBack()}>
              Back
            </button>
            {statusModalOpen && (
              <ChangeStatusModal
                isOpen={statusModalOpen}
                onSend={handleChangeStatusOnSend}
                onClose={() => {
                  setStatusModalOpen(false);
                }}
              />
            )}
          </>
        ) : (
          <div className={styles.loading}>
            <LoadingPage />
          </div>
        )}
      </section>
    </div>
  );
}
